// extracted by mini-css-extract-plugin
export default {"thanks":"thanks--emyRE","icon-wrapper":"icon-wrapper--a5vpa","iconWrapper":"icon-wrapper--a5vpa","icon":"icon--Qbkg2","text":"text--d_xz1","blink":"blink--OyeBp"};